'use client';

import { c as _c } from "react/compiler-runtime";
import { Heart, HeartSolid } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { SAVE_TRIP_TRACKING_ID } from '~/components/Common/SaveButton/src/useSaveTrip';
import { Dialog, DialogContent, DialogHeader } from '~/components/Dialog';
import { useTripSave } from '~/hooks/useTripSave';
import { trackEvent } from '~/utils';
import styles from './SaveTripButton.module.css';
type SaveTripButtonProps = {
  tripId: string | null | undefined;
  className: string;
  size: 'small' | 'large';
  iconVariant?: 'default' | 'overviewIntro';
};
export const SaveTripButton = t0 => {
  const $ = _c(46);
  const {
    tripId,
    className,
    size,
    iconVariant: t1
  } = t0;
  const iconVariant = t1 === undefined ? "default" : t1;
  const t = useTranslations("journey");
  const tAccount = useTranslations("account");
  const {
    isTripSaved,
    isLoginOpen,
    setIsLoginOpen,
    handleSave,
    handleLogin
  } = useTripSave(tripId);
  const iconSize = iconVariant === "overviewIntro" ? "small" : size;
  let t2;
  if ($[0] !== t) {
    t2 = t("overview_save_trip");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== handleSave) {
    t3 = () => {
      trackEvent(SAVE_TRIP_TRACKING_ID, {
        event_category: "click",
        event_label: SAVE_TRIP_TRACKING_ID
      });
      handleSave();
    };
    $[2] = handleSave;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconSize || $[5] !== isTripSaved) {
    t4 = isTripSaved ? <HeartSolid decorative={true} isInline={true} size={iconSize} /> : <Heart decorative={true} isInline={true} size={iconSize} />;
    $[4] = iconSize;
    $[5] = isTripSaved;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <button type="button" className={className} aria-label={t2} onClick={t3}>{t4}</button>;
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== setIsLoginOpen) {
    t6 = () => setIsLoginOpen(false);
    $[12] = setIsLoginOpen;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== tAccount) {
    t7 = tAccount("save_defer");
    $[14] = tAccount;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <DialogHeader variant="notification" hasPadding={false}>{t7}</DialogHeader>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== tAccount) {
    t9 = tAccount("login_prompt_save");
    $[18] = tAccount;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <DialogContent><p>{t9}</p></DialogContent>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== setIsLoginOpen) {
    t11 = () => setIsLoginOpen(false);
    $[22] = setIsLoginOpen;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== tAccount) {
    t12 = tAccount("defer");
    $[24] = tAccount;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <Button onPress={t11} size="fullWidth" variant="tertiary" isPillShape={true}>{t12}</Button>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== tAccount) {
    t14 = tAccount("log_in");
    $[29] = tAccount;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleLogin || $[32] !== t14) {
    t15 = <Button onPress={handleLogin} size="fullWidth" isPillShape={true}>{t14}</Button>;
    $[31] = handleLogin;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t15) {
    t16 = <div className={styles.dialogFooter}>{t13}{t15}</div>;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== isLoginOpen || $[38] !== t10 || $[39] !== t16 || $[40] !== t6 || $[41] !== t8) {
    t17 = <Dialog isOpen={isLoginOpen} onOpenChange={t6} hasPadding={true}>{t8}{t10}{t16}</Dialog>;
    $[37] = isLoginOpen;
    $[38] = t10;
    $[39] = t16;
    $[40] = t6;
    $[41] = t8;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17 || $[44] !== t5) {
    t18 = <>{t5}{t17}</>;
    $[43] = t17;
    $[44] = t5;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  return t18;
};